<template>
  <div class="ELYXModalText" :style="getCustomStyles">
    <slot></slot>
  </div>
</template>

<script>
import { ELYXCentralStore } from "../ELYX/ELYXStore";
export default {
  computed: {
    activeModal: () => ELYXCentralStore.state.activeModal,

    getCustomStyles() {
      if (this.activeModal.isInfoModal) {
        return `
          text-align: justify !important;
        `;
      }
      return ``;
    },
  },
};
</script>

<style></style>

<style>
.ELYXModalText {
  line-height: 26px;
  margin: 5px auto;
  margin-bottom: 10px;
  margin-left: 0;
  text-align: center;
}
</style>
